import React from 'react';

const ResultQuestionsMap = ({ questions, onQuestionSelected }) => {
    const questionClass = status => {
        switch (status) {
            case 'CORRETA': return 'correct';
            case 'ERRADA': return 'wrong';
            case 'NAO_RESPONDIDA': return 'unanswered';
            default: return ''
        }
    };

    return (
        <div className="questions-map">
            <div className="questions-map__lines">
                <div className="questions-map__line">
                    {
                        questions && questions.map((question, index) => {
                            return(
                                <div
                                    key={`questions + ${index}`}
                                    className={`questions-map__question ${questionClass(question.resultado)}`}
                                    onClick={() => onQuestionSelected(question.index)}
                                >
                                    { question.index + 1 }
                                </div>
                            )

                        })
                    }
                </div>
            </div>
            <div className="questions-map__legend">
                <small>Clique no número para abrir a questão</small>
            </div>
        </div>
    )
};

export { ResultQuestionsMap }
